import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'react-toastify/dist/ReactToastify.css';
import LogoAndText from '../components/LogoAndText';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faArrowLeft, faPhone } from '@fortawesome/free-solid-svg-icons';
import { Avatar, List, ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import { grey } from '@mui/material/colors';
import { contactUs } from '../apiServices/apiServices';
import { toast } from "react-toastify";
import CustomToastContainer from '../components/CustomToastContainer';
import { useNavigate } from 'react-router-dom';

export default function ContactUs() {
  const navigate = useNavigate();
  const [phone, setPhone] = useState('');
  const [whatsapp, setWhatsapp] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      await contactUsMethod();
    };

    fetchData();
  }, []);

  const contactUsMethod = async () => {
    try {
      const response = await contactUs();
      // console.log("Contact Us API Response:", response);
      if (response && response.success) {
        const { contactNumbersService } = response.data;
        setWhatsapp(contactNumbersService?.[0]?.value || 'Not available');
        setPhone(contactNumbersService?.[1]?.value || 'Not available');
    } else {
        toast.error(response?.message || 'Something went wrong.');
      }
    } catch (error) {
      console.error("Error occurred:", error);
      toast.error('An error occurred. Please try again.');
    }
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <div className='bg-gray-100 h-screen'>
      <nav className="flex items-center justify-between p-2 sm:p-4 bg-white shadow-md">
          <button className="text-gray-600 items-center" onClick={() => handleNavigation(-1)}>
            <FontAwesomeIcon icon={faArrowLeft} size="lg" />
          </button>
          <div className="flex items-center justify-center flex-grow gap-2">
            <h1 className="text-gray-600 font-semibold text-lg">
            Contact Us
            </h1>
          </div>
        </nav>

      <div className="flex flex-col items-center h-screen p-4 md:p-10">
        <div className="w-full md:w-1/2 py-10">
          <div className="mb-10">
            <LogoAndText />
          </div>
          <h1 className="text-gray-500 text-xs md:text-sm text-center mb-4 px-2 md:mb-6">
          You can get in touct with us through below platforms. Our <br/>
          team will reach out to you as soon as it would be possible 
          </h1>

          <div className="flex flex-col items-center space-y-6">
            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
              <ListItem>
                <ListItemAvatar>
                  <Avatar sx={{ bgcolor: grey[300] }}>
                    <FontAwesomeIcon icon={faPhone} size="sm" className="text-[#BE1F18]" />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary="Call"
                  secondary={phone !== 'Not available' ? (
                    <a href={`tel:${phone}`} className="text-blue-600 underline">
                      {phone}
                    </a>
                  ) : (
                    'Not available'
                  )}
                />
              </ListItem>
              <hr />
              <ListItem>
                <ListItemAvatar>
                  <Avatar sx={{ bgcolor: grey[300] }}>
                    <FontAwesomeIcon icon={faWhatsapp} size="xl" className="text-[#BE1F18]" />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary="WhatsApp"
                  secondary={
                    whatsapp !== 'Not available' ? (
                      <a 
                        href={`https://wa.me/${whatsapp}`} 
                        target="_blank" 
                        // rel="noopener noreferrer" 
                        className="text-blue-600 underline"
                      >
                        {whatsapp}
                      </a>
                    ) : (
                      'Not available'
                    )
                  }
                />
              </ListItem>
            </List>
          </div>
        </div>
        <CustomToastContainer />
      </div>
    </div>
  );
}
